var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('has-request-error',{attrs:{"has-error":_vm.requestError,"is-loading":_vm.isReloading},on:{"retry":_vm.reloadData}},[_c('image-carousel',{attrs:{"images":_vm.images,"is-loading":_vm.isLoading,"is-disabled":_vm.isDisabled}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }